import React, { MutableRefObject, useImperativeHandle, useMemo, useState } from 'react';
import { AuthViewType } from '../AuthButtonProps';
import { NewAuthFormContext, NewAuthFormState } from './NewAuthFormContext';

interface NewAuthFormProviderProps {
    children: any;
    view?: AuthViewType;
    apiRef?: MutableRefObject<NewAuthFormState>;
    title?: string;
    cta?: string;
    from?: string;
    isNewUser?: (value: boolean) => void;
}

export function NewAuthFormProvider({
    view: activeView,
    title,
    apiRef,
    cta,
    from,
    children,
    isNewUser,
}: NewAuthFormProviderProps) {
    const [view, setView] = useState(() => activeView ?? 'main');

    const state = useMemo<NewAuthFormState>(
        () => ({
            view,
            setView,
            title,
            cta,
            from,
            isNewUser,
        }),
        [view, setView, title],
    );

    useImperativeHandle(apiRef, () => state, [state]);

    return <NewAuthFormContext.Provider value={state}>{children}</NewAuthFormContext.Provider>;
}

export default NewAuthFormProvider;
